import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {promotionActions} from "./promotionSlice";
import {promotionApi} from "../../api";

function* fetchDemoList(action)
{
	try
	{
		const response = yield call(promotionApi.get, action.payload);
		yield put(promotionActions.fetchDataSuccess(response))
	}
	catch (error)
	{
		let message = error.message;
		if(error?.response?.data?.message) message = error.response.data.message;
		yield put(promotionActions.fetchDataFailed(message));
	}
}

function* handleSearchDebounce(action)
{
	yield put(promotionActions.setFilter(action.payload));
}

export default function* promotionSaga()
{
	yield takeLatest(promotionActions.fetchData.type, fetchDemoList);
	yield debounce(500, promotionActions.setFilterWithDebounce.type, handleSearchDebounce)
}